/*
 * @Author: syyoon@yongtrim.com
 * @Date: 2018-07-09 17:19:03
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2019-01-19 20:49:51
 */

import { Environment } from "./env.interface";

export const ENV: Environment = {
  PRODUCTION: true,
  API_PATH: "celeb",
  SERVER_URL: "https://k-rush.online",
  S3_URL: "https://s3.us-east-2.amazonaws.com/k-rush",
  VIMEO_TOKEN: "4c8b929b09925bf7dd8f7007ae585908",
  WEB_VERSION: "0.5.0",
  DENY_REGIST_KOREAN: false
};



// WEBPACK FOOTER //
// ./src/env/env.ts